__turbopack_context__.v({
  "actions": "ThemeStudio-module___-1RfG__actions",
  "btn": "ThemeStudio-module___-1RfG__btn",
  "btnPrimary": "ThemeStudio-module___-1RfG__btnPrimary",
  "customs": "ThemeStudio-module___-1RfG__customs",
  "field": "ThemeStudio-module___-1RfG__field",
  "gate": "ThemeStudio-module___-1RfG__gate",
  "meta": "ThemeStudio-module___-1RfG__meta",
  "panel": "ThemeStudio-module___-1RfG__panel",
  "preview": "ThemeStudio-module___-1RfG__preview",
  "row": "ThemeStudio-module___-1RfG__row",
  "studio": "ThemeStudio-module___-1RfG__studio",
  "sub": "ThemeStudio-module___-1RfG__sub",
  "swatchStrip": "ThemeStudio-module___-1RfG__swatchStrip",
  "title": "ThemeStudio-module___-1RfG__title",
});
